import { AsyncPipe } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FieldType, FormlyModule } from "@ngx-formly/core";
import { FormlySelectModule } from "@ngx-formly/core/select";
import { Message } from "primeng/message";
import { NewUiFlagComponent } from "../../shared/flag/new-ui-flag.component";
import { NewUiDropdownComponent } from "../../shared/form/dropdown/new-ui-dropdown.component";
import { NewUiFormElementMapModule } from "../../shared/from-element-map/new-ui-form-element-map.module";
import { TestIdDirective } from "../../shared/test-id/test-id.directive";
import { DropdownPrePopulateSingleOptionDirective } from "../../shared/primeng/dropdown-pre-populate-single-option/dropdown-pre-populate-single-option.directive";

@Component({
  selector: "new-ui-formly-dropdown",
  templateUrl: "./new-ui-formly-dropdown.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NewUiDropdownComponent,
    ReactiveFormsModule,
    FormlyModule,
    FormlySelectModule,
    AsyncPipe,
    NewUiFormElementMapModule,
    TestIdDirective,
    Message,
    NewUiFlagComponent,
    DropdownPrePopulateSingleOptionDirective,
  ],
})
export class NewUiFormlyDropdownComponent extends FieldType {
  override defaultOptions = {
    props: { options: [] },
  };
}
